<template>
  <el-form-item :label="i18nt('designer.setting.fileMaxSize')">
    <el-input-number
      v-model="optionModel.fileMaxSize"
      :min="1"
      class="hide-spin-button"
      style="width: 100%"
    />
  </el-form-item>
</template>

<script>
import i18n from '@/utils/i18n'

/* eslint-disable */
export default {
  name: 'FileMaxSizeEditor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped>

</style>
